import React from "react";
import AxiosConfig from "axiosConfig";
import {connect} from "react-redux";
import TextTheme from "components/General/Text/TextTheme";

class Logout extends React.Component {

    componentDidMount() {
    const props = this.props;
      AxiosConfig
      .post(`account/exit/`, this.state)
      .then(function(response) {
        window.sessionStorage.clear()
        props.dispatch({ type: "LOGOUT_SUCCESS"});
      });
    }

  render() {
    return (
        <div style={{ display: "block", paddingTop: "50px", backgroundColor:"white", textAlign:"center"}}>
            <a href="/log-in"><TextTheme message="Login Again" className="text_medium text_dark_blue"/></a>

        </div>
    );
  }
}

export default connect()(Logout);